export default () => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.87803 10.4399L2.65578 7.19159C2.16541 6.69726 1.36615 6.69726 0.875784 7.19159C0.390965 7.68033 0.390965 8.46858 0.875784 8.95732L4.88515 12.9991C5.43221 13.5506 6.32386 13.5506 6.87092 12.9991L17.1242 2.66292C17.609 2.17418 17.609 1.38593 17.1242 0.897192C16.6338 0.402859 15.8346 0.40286 15.3442 0.897193L5.87803 10.4399Z"
      fill="currentColor"
    />
  </svg>
);
